import $ from 'jquery';
import { getState } from '~src/state';

export function updateTextBorderColorControl() {
  let strokeColor;
  const activeObject = getState('activeObject');

  // If ActiveSelection of texts, derive a common or mixed color
  if (
    activeObject &&
    activeObject.type === 'activeSelection' &&
    typeof activeObject.getObjects === 'function'
  ) {
    const texts = activeObject
      .getObjects()
      .filter((o) => o.type === 'textbox' || o.type === 'i-text');
    if (texts.length) {
      const colors = Array.from(
        new Set(
          texts.map((t) => {
            const c = t.get('stroke');
            return c == null ? 'transparent' : String(c);
          })
        )
      );
      strokeColor = colors.length === 1 ? colors[0] : null;
      // Update UI for mixed
      $('#color-text-border').css('background-color', strokeColor || '#cbd5e1');
      const $mainButton = $('#color-text-border-main');
      if (strokeColor && strokeColor !== 'transparent') {
        $mainButton.addClass('active').css('border-color', strokeColor);
      } else {
        $mainButton.removeClass('active').css('border-color', '#ccc');
      }
      return;
    }
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      strokeColor = activeObject.get('stroke');
    } else if (selectionStart === selectionEnd) {
      strokeColor = activeObject.get('stroke');
    } else {
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        strokeColor =
          selectionStyles[0]['stroke'] || activeObject.get('stroke');
      } else {
        strokeColor = activeObject.get('stroke');
      }
    }
  } else {
    strokeColor = activeObject.get('stroke');
  }

  $('#color-text-border').css('background-color', strokeColor || 'transparent');

  // Update main button appearance based on border state
  const $mainButton = $('#color-text-border-main');
  if (strokeColor && strokeColor !== 'transparent' && strokeColor !== null) {
    $mainButton.addClass('active').css('border-color', strokeColor);
  } else {
    $mainButton.removeClass('active').css('border-color', '#ccc');
  }
}
